<template>
  <svg
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.28952 0L2.21182 6.79639V10.2663H3.7042V7.79033H9.37569V1.44925H21.2921V10.2666H22.7856V0.000575297L8.28952 0Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.70433 20.8528H21.2922V25.5506L3.70433 25.5339V20.8528ZM4.10719 13.255C5.03071 13.2572 5.95627 13.2482 6.8794 13.2598C7.61595 13.2887 8.29887 13.7881 8.51606 14.4739C8.76321 15.2063 8.57624 16.1222 7.89898 16.5776C7.49431 16.8746 6.97328 16.9346 6.48168 16.9164H5.34574V19.0047H4.10719V13.255ZM9.52685 13.255H10.8392L13.1931 16.9515V13.255H14.3523V19.0041H13.2095L10.6766 15.1408V19.0041H9.52699L9.52685 13.255ZM18.2091 13.0642C18.6523 13.0557 19.096 13.1329 19.5025 13.293C20.2391 13.5751 20.8311 14.249 20.8833 15.0304H19.6349C19.5322 14.3781 18.7914 14.0049 18.1607 14.0649C17.5116 14.0893 16.9607 14.5795 16.7891 15.17C16.5876 15.8509 16.5766 16.6147 16.8782 17.2712C17.1209 17.8306 17.7262 18.243 18.3639 18.1879C19.0635 18.1738 19.7219 17.6022 19.7337 16.9078V16.8741H18.4213V15.9134H20.8928V19.0016H19.8683C19.8591 18.8107 19.8503 18.622 19.8407 18.4312C19.4817 19.0199 18.7254 19.204 18.0644 19.2014C17.3968 19.2171 16.7477 18.933 16.2908 18.4695C15.4766 17.6502 15.2348 16.4173 15.4607 15.3255C15.6201 14.5038 16.13 13.7147 16.9302 13.3527C17.3286 13.1664 17.7675 13.0736 18.2091 13.0642ZM0.5 11.4133V20.8521H2.21175V26.9804L22.7857 27V20.8525H24.5V11.4131L0.5 11.4133Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.45169 14.2497C6.25817 14.2476 6.06154 14.2587 5.867 14.2518H5.34557V15.9384H6.52279C6.87525 15.9486 7.28172 15.845 7.43486 15.5034C7.64729 15.0932 7.50777 14.487 7.0275 14.3251C6.84104 14.2654 6.64611 14.2518 6.45169 14.2497Z"
      fill="currentcolor"
    />
  </svg>
</template>
